<template>
  <div class="card m-5">
    <div class="card-header">
      <img src="../assets/logo.png" id="logo" class="inline align-middle mr-2" alt="logo">
      <h1 class="inline align-middle">Den Udvidede Danske Ordbog</h1>
    </div>
    <div class="card-body">
    <div class="container-fluid" id="form">
      <form v-on:submit.prevent="onSubmit" class="form-inline">
        <div class="form-group">
          <input type="text" v-model="word" class="form-control mr-2"
                 id="word" placeholder="Skriv et ord"
                 ref="word" v-on:keydown="onChange">
        </div>
        <div class="form-check form-check-inline">
          <input type="radio" id="nature-sb" value="substantiv" class="mr-1"
                 v-on:change="onChange" v-model="nature">
          <label for="nature-sb" class="mr-2">Noun</label>
          <input type="radio" id="nature-adj" value="adjektiv" class="mr-1"
                 v-on:change="onChange" v-model="nature">
          <label for="nature-adj" class="mr-2">Adjective</label>
          <input type="radio" id="nature-vb" value="verbum" class="mr-1"
                 v-on:change="onChange" v-model="nature">
          <label for="nature-vb" class="mr-4">Verb</label>
        </div>
        <button type="submit" class="btn btn-primary my-2"
                :disabled="buttonDisabled == true">Søg / Search</button>
        <span id="button-helper" class="ml-2"
        v-bind:class="classButtonHelper">
          {{ buttonHelper }}
        </span>
      </form>
    </div>
    <div class="container-fluid" v-if="show" id="div-result">
      <h2>Bøjning / Declension</h2>
      <table class="table table-sm table-bordered table-fixed">
        <thead class="thead-light">
          <tr>
            <th scope="col" v-for="(value, key) in res.declensions"
                v-bind:key="key">{{ value.name }}</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td v-for="(value, key) in res.declensions"
                v-bind:key="key">{{ value.value }}</td>
          </tr>
        </tbody>
      </table>
      <h2>Udtale / Pronunciation</h2>
      <p v-if='!multiple_sound'>
        {{ res.sound_text[0] }}
        <button v-on:click="playAudio(0)" class="btn btn-sm btn-outline-secondary"
                v-if="res.sound_audio[0]">Listen</button>
      </p>
      <ul v-if='multiple_sound'>
        <li v-for="(value, key) in res.sound_text" v-bind:key="key">
        {{ value }}
        <button v-on:click="playAudio(key)" class="btn btn-sm btn-outline-secondary"
                v-if="res.sound_audio[key]">Listen</button>
        </li>
      </ul>
      <h2>Betydning / Definition</h2>
      <p>{{ res.definition }} (<a v-bind:href="'https://ordnet.dk/ddo/ordbog?query=' + word" target="_blank">ordnet.dk</a>)</p>
      <h2>Oversættelse / Translation</h2>
      <table class="table table-sm table-bordered table-fixed">
        <thead class="thead-light">
          <tr>
            <th scope="col">English</th>
            <th scope="col">Français</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(value, key) in res.translation_en" v-bind:key="key">
            <td v-html="res.translation_en[key]"></td>
            <td v-html="res.translation_fr[key]"></td>
          </tr>
        </tbody>
      </table>
    </div>
    </div>
    <div class="card-footer">
    -- <a href="https://blog.tmlmt.com/custom-danish-dictionary/">tmlmt</a>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Search',
  data() {
    return {
      buttonHelper: '',
      buttonDisabled: false,
      show: false,
      word: null,
      nature: 'substantiv',
      res: {
        status: 0,
        declensions: [],
        sound_text: [],
        sound_audio: [],
        definition: '',
        translation: [],
      },
      multiple_sound: false,
      audio: new Audio(),
    };
  },
  computed: {
    classButtonHelper() {
      return {
        'text-primary': this.res.status === 2,
        'text-success': this.res.status === 1,
        'text-danger': this.res.status === 0,
      };
    },
  },
  mounted() {
    this.focusInput();
  },
  methods: {
    onSubmit() {
      this.buttonDisabled = true;
      this.res.status = 2;
      this.buttonHelper = 'Searching ...';
      const path = 'https://ordbog.tmlmt.com/api/search';
      axios.get(path, {
        params: {
          word: this.word,
          nature: this.nature,
        },
      })
        .then((res) => {
          const resData = res.data;
          for (let i = 0; i < resData.translation_fr.length; i += 1) {
            resData.translation_fr[i] = resData.translation_fr[i].replace(/{p}([^{]*){p}/g, '<span class="trans-prep">$1</span>');
            resData.translation_fr[i] = resData.translation_fr[i].replace(/{c}([^{]*){c}/g, "<span class='trans-context'>$1</span>");
          }
          for (let i = 0; i < resData.translation_en.length; i += 1) {
            resData.translation_en[i] = resData.translation_en[i].replace(/{p}([^{]*){p}/g, "<span class='trans-prep'>$1</span>");
            resData.translation_en[i] = resData.translation_en[i].replace(/{c}([^{]*){c}/g, "<span class='trans-context'>$1</span>");
          }
          this.res = resData;
          if (this.res.sound_text.length > 1) {
            this.multiple_sound = true;
          } else {
            this.multiple_sound = false;
          }
          if (this.res.status === 1) {
            this.show = true;
            this.buttonHelper = 'Word found!';
          } else {
            this.show = false;
            this.buttonHelper = 'Word not found!';
          }
        })
        .catch((error) => {
          console.error(error);
          this.buttonHelper = 'Error encountered';
        });
    },
    onChange() {
      this.buttonHelper = '';
      this.buttonDisabled = false;
    },
    playAudio(key) {
      this.audio.src = `https://cors-anywhere.herokuapp.com/${this.res.sound_audio[key]}`;
      this.audio.crossOrigin = 'anonymous';
      this.audio.play();
    },
    focusInput() {
      this.$refs.word.focus();
    },
  },
};
</script>

<style>
.trans-context {
  color: #ff9501;
  font-size: 0.8rem;
}
.trans-prep {
  color: #ff9501;
  font-style: italic;
  font-size: 0.8rem;
}
.inline {
  display: inline;
}
#logo {
  width: 50px;
}
#div-result {
  margin-top: 20px;
}
.table-fixed {
  table-layout: fixed;
}
</style>
